import React from 'react';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { AddPortfolioBlock } from './AddPortfolioBlock';
import { FreelancerPortfolio } from './FreelancerPortfolio';
import { usePortfolio } from './usePortfolio';

export const PortfolioResolver: React.FC = () => {
    const { seller, username, isCurrentUser, isEligibleSeller } = useFreelancerPageContext();
    const { hasPortfolio, portfolio } = usePortfolio();

    if (hasPortfolio && portfolio && seller) {
        return <FreelancerPortfolio seller={seller} />;
    }

    if (!hasPortfolio && isCurrentUser && isEligibleSeller) {
        return <AddPortfolioBlock username={username} />;
    }

    return null;
};

export default PortfolioResolver;
